<template>
    <div class="con" @mouseout="HiddenList">
        <!-- 侧边栏的移动竖线 -->
        <!-- <div class="lie_line" ref="lie_line"></div> -->
        <!-- 侧边栏主体 -->
        <div class="header">
            <!-- <img src="../../../assets/Vector.png" /> -->
            <div style="font-size: 20px; margin-right: 20px" class="haed-name">
                <div>OOG202</div>
                <!-- <div class="bbh">v2</div> -->
            </div>
            <div>
                <el-button
                    type="primary"
                    size="mini"
                    style="background-color: rgb(121, 174, 200)"
                    @click="fabu"
                    :loading="publishState"
                    >Publish</el-button
                >
                <el-button
                    type="primary"
                    size="mini"
                    style="background-color: rgb(121, 174, 200)"
                    @click="download"
                    download="data.json"
                    >Json</el-button
                >
            </div>
        </div>
        <div
            style="
                text-align: left;
                margin: 10px 0 20px 20px;
                font-size: 12px;
                text-transform: none;
            "
        >
            (current version：v{{ version }})
        </div>
        <el-menu :default-active="active" @select="cutPage">
            <div v-for="(item, index) in listdom" :key="index" class="kuai">
                <div v-if="item.noShow"></div>
                <div v-else>
                    <el-menu-item
                        v-if="!item.children || item.noFold"
                        :index="item.path"
                    >
                        <i :class="[item.icon, 'icon1']"></i>
                        <span slot="title">{{ item.meta }}</span>
                    </el-menu-item>
                    <!-- 有子元素 -->
                    <el-submenu v-else :index="item.path">
                        <template slot="title">
                            <i :class="[item.icon, 'icon1']"></i>
                            <span>{{ item.meta }}</span>
                        </template>
                        <el-menu-item-group
                            v-for="(item2, index2) in item.children"
                            :key="index2"
                        >
                            <div v-if="item2.noShow"></div>
                            <el-menu-item
                                :index="item.path + '/' + item2.path"
                                v-else
                            >
                                <!-- <i :class="[item2.icon, 'icon1']"></i> -->
                                <span
                                    style="
                                        width: 30px;
                                        opacity: 0;
                                        height: 10px;
                                    "
                                    >1111</span
                                >
                                <span>{{ item2.meta }}</span>
                            </el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                </div>
            </div>
        </el-menu>
    </div>
</template>
<script>
import single from "../../../assets/js/single";
export default {
    data() {
        return {
            listdom: [],
            listLineHeight: null,
            publishState: false,
            version: 2,
        };
    },
    methods: {
        //获取版本号
        download() {
            window.open("/oog202/manage/pub/download");
            // let zip = new this.$JsZip();
            // console.log(zip);
            // this.$request2("/manage/pub/sendData", {}, (res) => {
            //     if (res.data.code === 200) {
            //         for(let item in res.data.data){
            //             zip.file(`${item}.json`,res.data.data[item])
            //         }
            //         zip.generateAsync({type:'blob'}).then(content => {
            //             let url = URL.createObjectURL(content)
            //             let a = document.createElement('a')
            //             a.download = 'JSON.zip'
            //             a.href = url
            //             a.click()
            //         })
            //     }
            // });
            // let input = document.createElement('input')
            // input.type = 'file'
            // input.onchange = () => {
            //     let file = input.files[0]
            //     this.$uploadJSON('/OOG202/data/1.1.0/'+file.name,file,(e) => {
            //         console.log(e)
            //     })
            // }
            // input.click()
        },
        getVersion() {
            this.$request2("/manage/pub/version", {}, (res) => {
                this.version = res.data.data;
            });
        },
        fabu() {
            this.publishState = true;
            (async () => {
                // 发布
                await new Promise((resolve) => {
                    this.$request2("/manage/pub/sendData", {}, (res) => {
                      this.version = res.data.data;
                      resolve()
                    });
                });
                this.publishState = false;
            })();
        },
        cutPage(e) {
            this.$router.push(e);
            // 移动端适配
            this.$emit("clickbtn");
        },
        changeListStyle(e) {
            let classList = e.path[0].classList;
            for (let i = 0; i < classList.length; i++) {
                if (
                    classList[i] === "el-menu-item" ||
                    classList[i] === "el-submenu__title"
                ) {
                    let dom = e.path[0].getBoundingClientRect();
                    this.$refs["lie_line"].style.top = dom.top - 80 + "px";
                    this.$refs["lie_line"].style.height = dom.height + "px";
                }
            }
        },
        HiddenList() {
            // if(!e.fromElement){return false}
            // let classList = e.fromElement.classList
            // for(let i = 0; i < classList.length ;i++){
            //     if(
            //         e.relatedTarget.classList.value != 'lie_line'&&   //阻止滑动竖线冒泡
            //         e.relatedTarget.localName != 'span'&&            //阻止文字冒泡
            //         e.relatedTarget.localName != 'i'&&               //阻止icon冒泡
            //         e.relatedTarget.localName != 'ui'&&              //阻止整个导航栏冒泡
            //         e.relatedTarget.localName != 'li'&&              //阻止其他li标签冒泡
            //         (classList[i] === 'el-submenu__title' || classList[i] === 'el-menu-item')
            //     ){
            //         let h = e.fromElement.getBoundingClientRect().height
            //         this.$refs["lie_line"].style.height = 0 + "px";
            //         this.$refs["lie_line"].style.top = parseInt(this.$refs["lie_line"].style.top) + h/2 + 'px';
            //     }
            // }
        },
    },
    computed: {
        nowPath: {
            get() {
                return this.$route.path;
            },
            set(newdata) {
                this.$store.commit("modifyData", { name: "nowPath", newdata });
            },
        },
        active() {
            let state = "",
                defaultDom = {};
            this.listdom.some((item) => {
                if (item.defaultPath) {
                    defaultDom[item.path.match(/\/([^0]{0,})-/)[1]] = item.path;
                }
            });
            this.listdom.some((item) => {
                // console.log(item)
                // 优先级最高，设置组件默认绑定路由
                if (this.nowPath.search(item.path) != -1) {
                    state = item.path;
                    // return true
                }
                // 不显示的直接不绑定active
                if (item.noShow) {
                    return false;
                }
                // 路由扫描组件路径
                if (this.nowPath.search(item.path) != -1) {
                    state = item.path;
                    // return true
                }
                // 有子节点的情况,因为只有两层不使用递归
                if (item.children && item.children.length != 0) {
                    let defaultPath = "",
                        noShow = false;
                    item.children.some((item2) => {
                        // 设定noShow的默认导航路径
                        if (item2.defaultPath) {
                            defaultPath = item.path + "/" + item2.path;
                        }
                        if (this.nowPath.search(item2.path) != -1) {
                            if (item2.noShow) {
                                noShow = true;
                            }
                            //加上父路由
                            state = item.path + "/" + item2.path;
                        }
                    });
                    if (noShow) {
                        state = defaultPath;
                    }
                }
            });
            return state;
        },
    },
    created() {
        this.nowPath = this.$route.path;
        this.listdom = single.getRouterName(this.$router);
        this.getVersion();
    },
    mounted() {},
};
</script>

<style scoped>
.header {
    display: flex;
    padding: 20px 20px 0;
    box-sizing: border-box;
    align-items: center;
    flex-wrap: wrap;
}
.header img {
    width: 30px;
    height: 30px;
    object-fit: contain;
}
.header > div {
    margin-right: 15px;
}
@media screen and (max-width: 769px) {
    .lie_line {
        display: none !important;
    }
}
.lie_line {
    width: 5px;
    background-color: #3b8cff;
    position: absolute;
    height: 56px;
    left: 0;
    top: 0;
    z-index: 100;
    transition: all 0.2s;
}
.con {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
.el-menu {
    border-right: none;
    background-color: white;
}
.con >>> .el-menu-item {
    text-align: left;
}
.con >>> .el-menu-item:hover,
.con >>> .el-submenu__title:hover {
    color: #409eff !important;
}
.el-menu-item:focus {
    /* background-color: inherit !important; */
}
.con >>> .el-submenu__title {
    text-align: left;
}
.con >>> .el-menu-item-group__title {
    padding: 0;
}
.con >>> .el-menu-item-group {
    overflow: hidden;
}
.con >>> .el-menu-item-group li {
    width: 90%;
    min-width: auto;
    padding: 0 10px !important;
    margin: auto;
}
.kuai:hover {
    color: white;
}
.icon1 {
    color: inherit !important;
}
.con >>> .is-active {
    /* background-color: rgba(0,0,0,.08) !important; */
    color: #409eff;
}
.bbh {
    font-size: 12px;
    text-transform: none;
}
.header >>> * {
    text-transform: none;
}
</style>